<template>
  <v-app class="container_tabledata" color="#fff">
    <v-card elevation="0">
      <v-layout v-resize="onResize" column style="">
        <loadingTable v-if="!crewwatchData"/>
        <v-card v-if="crewwatchData" class="ma-3 elevation-0 rounded-0">
          <v-toolbar
        
            elevation="0"
            class="pa-0"
            color="#CCDBE3"
            fixed
            dense
          >
          <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPage)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="itemsPerPage = 5"
                  ><v-list-item-title>5</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 15"
                  ><v-list-item-title>15</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = crewwatchData.length"
                  ><v-list-item-title>All</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu>
            <v-spacer style="width: 70%"></v-spacer>
            <v-text-field
              width="40"
              light
              dense
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              class="elevation-0 rounded-0 mt-2"
            ></v-text-field>
          </v-toolbar>
          <v-data-table
            style="margin-top: 0px"
            v-if="crewwatchData"
            :search="search"
            :headers="headers"
            :items="crewwatchData"
            hide-default-footer
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 rounded-0 dataTable"
            @page-count="pageCount = $event"
          >
            <template v-slot:item="row">
              <tr>
                <td class="pa-0" style="white-space: nowrap;min-width:2.5em">{{ row.item.index + 1 }}</td>
                <td class="pa-0" style="white-space: nowrap;">{{ row.item.name }}</td>
                <td class="pa-0" style="white-space: nowrap;">{{ row.item.pt_name }}</td>
                <td class="pa-0" style="white-space: nowrap;">
                  <v-btn
                    @click="showCrews(row.item)"
                    color="primary"
                    dark
                    role="button"
                    class="pingbtn elevation-0 rounded-0"
                    style="min-width:23em"
                    small
                    ><i class="bx bxs-user"></i>&nbsp;&nbsp;Show Crew</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
          <div
            class="pt-0" style="background-color: #edecff"
          >
          <v-pagination
            v-model="page"
            color="#A1BBD7"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
          </div>

          <v-progress-linear
            v-if="!listcrew && showcrewclick"
            indeterminate
            color="#0B4281"
            height="7"
            striped
          ></v-progress-linear>
        </v-card>
      </v-layout>
     
    </v-card>
    <v-card class="elevation-0 rounded-0" v-if="listcrew">
        <v-card color="#F4F8FA" class=" ma-3 elevation-0 rounded-0 mt-0 pb-3">
          <v-toolbar color="#CCDBE3" class="elevation-0 rounded-0"  dense >
          <v-toolbar-title>{{ listcrew.vessel_pt }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
          class="mx-2 rounded-0 elevation-0"
          fab
          x-small
       
          color="#EDECFF"
          @click="removeShowCrew(), (showcrewclick = null)"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
         
        </v-toolbar>
    
          <v-card class="elevation-0 rounded-0 ma-3">
            <v-row v-if="listcrew" no-gutters style="flex-wrap: nowrap">
            <v-col
              cols="1"
              style="min-width: 100px; max-width: 100%; margin: 5px"
              class="flex-grow-1 flex-shrink-0"
            >
              <v-card class="pa-2" outlined tile>
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th :colspan="2" class="text-left">
                            Seafarer (Officer)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          @click="
                            showDetailCrews(item.id), (showcrewclick = true)
                          "
                          v-for="item in listcrew.list_officer"
                          :key="item.name"
                          style="cursor: pointer"
                        >
                          <td style="padding: 10px">
                            <p
                              class="font-weight-bold caption"
                              style="margin-bottom: 0"
                            >
                              {{ item.rank }}
                            </p>
                            {{ item.name }}
                          </td>
                          <td style="padding: 10px">
                            <v-badge :color="item.status" dot inline></v-badge>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="1"
              style="min-width: 100px; max-width: 100%; margin: 5px"
              class="flex-grow-1 flex-shrink-0"
            >
              <v-card class="pa-2" outlined tile>
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th :colspan="2" class="text-left">Crew</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          @click="
                            showDetailCrews(item.id), (showcrewclick = true)
                          "
                          v-for="item in listcrew.list_crew"
                          :key="item.name"
                          style="cursor: pointer"
                        >
                          <td>{{ item.name }}</td>
                          <td>
                            <v-badge :color="item.status" dot inline></v-badge>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-card>

       
            <v-card class="elevation-0 rounded-0 ma-3" v-if="detailcrew">
              <v-toolbar class="elevation-0 rounded-0" color="#AEDAE0" dense >
                {{ detailcrew.name_crew }}
              </v-toolbar>
              <v-toolbar class="elevation-0 rounded-0" color="#B7CAE1" dense>
                {{ detailcrew.range.range_actual }}
                <v-spacer> </v-spacer>
              
                  <v-text-field
              width="40"
              light
              dense
              v-model="searchCREW"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              class="elevation-0 rounded-0 mt-2 mr-1"
            ></v-text-field>
            <v-menu content-class="elevation-0 rounded-0 " offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#fff"  class="elevation-0 rounded-0 mr-1" v-bind="attrs" v-on="on" small>
                      <i class="bx bx-time"></i>
                      &nbsp; &nbsp;
                      <v-text v-if="detailcrew.range.range">{{
                        detailcrew.range.range
                      }}</v-text>
                      <v-card-text v-if="!detailcrew.range.range">
                        <div class="snippet" data-title=".dot-pulse">
                          <div class="stage">
                            <div class="dot-pulse"></div>
                          </div>
                        </div>
                      </v-card-text>
                      &nbsp; &nbsp;
                      <i class="bx bxs-chevron-down"></i>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(convid, 'hourly', 'LAST HOUR', inout),
                            delmodalConv()
                        "
                        >Last Hour</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(convid, '6hour', 'LAST 6 HOURS', inout),
                            delmodalConv()
                        "
                        >Last 6 Hour</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(
                            convid,
                            'today',
                            'LAST 24 HOURS',
                            inout
                          ),
                            delmodalConv()
                        "
                        >Last 24 Hour</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(convid, 'Daily', 'TODAY', inout),
                            delmodalConv()
                        "
                        >Today</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(
                            convid,
                            'yesterday',
                            'YESTERDAY',
                            inout
                          ),
                            delmodalConv()
                        "
                        >Yesterday</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                        block
                        plain
                        small
                        @click="
                          sendModalConv(convid, 'Weekly', 'LAST 7 DAYS', inout),
                            delmodalConv()
                        "
                        >Last 7 Days</v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                       
                        block
                        plain
                        small
                        @click="
                          sendModalConv(
                            convid,
                            'Monthly',
                            'LAST 30 DAYS',
                            inout
                          ),
                            delmodalConv()
                        "
                        >Last 30 Days</v-btn
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPageCREW)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="itemsPerPageCREW = 5"
                  ><v-list-item-title>5</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageCREW = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageCREW = 15"
                  ><v-list-item-title>15</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageCREW = detailcrew.message.length"
                  ><v-list-item-title>All</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu>
              </v-toolbar>
              <v-data-table
                style="margin-top: 0px"
               
                :headers="headersDetail"
                :items="detailcrew.message"
                :items-per-page="5"
                class="elevation-0 dataTable"
                :search="searchCREW"
              >
                <template v-slot:item="row">
                  <tr>
                    <!-- <td>{{row.index}}</td> -->
                    <td>{{ row.item.Name }}</td>
                    <td>{{ row.item.ip }}</td>
                    <td>{{ row.item.volume }}</td>
                    <td>{{ row.item.traffic }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
        
       
        </v-card>
    </v-card>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loadingTable from "@/components/progress/loadingTable.vue"
import * as easings from "vuetify/lib/services/goto/easing-patterns";
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    loadingTable
  },
  data() {
    return {
      searchCREW:'',
      showcrewdetailclick: null,
      actif: "none",
      items: [5, 10, 15, "All"],
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      show: false,
      showCrew: null,
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      showcrewclick: null,
      mrtgopen: false,
      notifopen: false,
      mrtgData: null,
      notifData: null,
      selectedNotif: "",
      search: "",
      search_name: localStorage.getItem("search_name"),
      search_nav: localStorage.getItem("search_nav"),
      showmaptable: "",
      showmaptracking: null,
      showmapclick: null,
      index: "",
      switch1: true,
      itemsPerPageCREW: 5,
      pageCREW: 1,
      pageCountCREW: 0,
      loadernavplus: require("@/assets/img/load100new.gif"),
      headers: [
        {
          text: "No",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Vessel Name", value: "name", width: "20%" },
        { text: "Company", value: "Quota", width: "50%" },
        { text: "Crew", value: "pt_name", width: "50%" },
      ],
      headersDetail: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "",
        },
        { text: "(Latitude, Longitude)", value: "name", width: "20%" },
        { text: "Skin Temperature (°C)", value: "Quota", width: "50%" },
        {
          text: "Heart Rate (Beat per Minutes)",
          value: "pt_name",
          width: "50%",
        },
        { text: "Calorie (kcal)", value: "pt_name", width: "50%" },
        { text: "Walk (Steps)", value: "pt_name", width: "50%" },
        { text: "Distance (Meter)", value: "pt_name", width: "50%" },
        { text: "Date/Time (GMT+7)", value: "pt_name", width: "50%" },
        { text: "Status", value: "pt_name", width: "50%" },
      ],
    };
  },

  async created() {
    this.fetchCrewwatch(localStorage.getItem("token"));
  },

  methods: {
    ...mapActions([
      "fetchCrewwatch",
      "showCrewData",
      "showCrewDetail",
      "removeShowCrew",
    ]),

    


    async showCrews(item) {
      this.$vuetify.goTo(this.target, this.options);
      console.log(item);
      const data = {
        id: item.id,
        token: localStorage.getItem("token"),
      };
      this.showCrewData(data);
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    async showDetailCrews(item) {
      this.$vuetify.goTo(this.target, this.options);
      console.log(item);
      const data = {
        id: item,
        token: localStorage.getItem("token"),
      };

      this.showCrewDetail(data);
    
    },
  },

  computed: {
    ...mapGetters(["crewwatchData", "listcrew", "detailcrew"]),

    ListOficer: function () {
      return this.listcrew.crews.filter(function (lc) {
        return lc.rank;
      });
    },
    ListCrews: function () {
      return this.listcrew.crews.filter(function (lc) {
        return !lc.rank;
      });
    },
    target() {
      return 62000000;
    },
    options() {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
    },
  }, //
};
</script>

<style lang="scss">
@import "@/assets/css/tabledata.css";

.header_modal {
  text-align: left;
}
.content_modal {
  margin-top: 20px;
}

.mrtg_title {
  color: #121212;
}

.v-btn {
  min-width: 36px;
  font-size: 8px;
}

.v-btn .pingbtn {
  width: 20px;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}

.v-application--wrap .v-application--wrap {
  min-height: 0px;
}

.container_table {
  margin-top: 13vh;
}
</style>
